import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { ROUTES } from '../../server-route';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReachedService extends ApiService {
  public fetfetchReached(pageNo: number, reqData: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.REACH_PENDING_DATA, {
        pageNo: pageNo,
      }),
      {
        params: reqData,
      }
    );
  }
  public fetchRestoredData(pageNo: number, reqData: any): Observable<any> {
    return this.get<any>(
      this.replacePathInfo(ROUTES.REACH_PENDING_DATA, {
        pageNo: pageNo,
      }),
      {
        params: reqData,
      }
    );
  }
  public addReach(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.REACH_ADD, {
      body: reqData,
    });
  }
}
